import {
    Backdrop,
    CircularProgress,
    Container, createTheme, Divider, IconButton, MuiThemeProvider
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import {
    Add as AddIcon, Close as CloseIcon,
    Delete as DeleteIcon,
    DoneAll as DoneAllIcon,
    Save as SaveIcon
} from '@material-ui/icons';
import MUIDataTable from 'mui-datatables';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation, UseTranslationResponse } from 'react-i18next';
import * as Yup from 'yup';
import Select from "../../components/Form/Select";
import { Switch } from "../../components/Form/Switch";
import TextField from '../../components/Form/TextField';
import AlertDialog from '../../components/ui/AlertDialog';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { city, Company, UF } from '../../interfaces/City';
import { MDFe, MDFeConductor, MDFeInvoice, MDFePost, MDFeRoute, MDFeUnloading } from '../../interfaces/MDFe';
import { VehiclePost, VehicleSearch } from '../../interfaces/Vehicle';
import MDFeApi from '../../services/MDFeApi';
import VehicleApi from '../../services/VehicleApi';
import VehicleTypeApi from '../../services/VehicleTypeApi';
import { MDFE_UNIDADE_MEDIDA } from '../../utils/constants';
import If from '../../utils/if';
import { useStyles } from './Style';

type Props = {
    mdfeId: number,
    traduction: UseTranslationResponse,
    clickHandlerClose: () => void,
    clickHandlerCalbkack: () => void,
}

interface IFormInput {
    newInvoiceKey?: string;
    newConductorCPF?: string;
    newConductorName?: string;
    newUFRoute?: any;
    newUFUnloading?: any;
    newCityUnloading?: any;
    loadingUFSelect?: any;
    loadingCitySelect?: any;
    unloadingUFSelect?: any;
    vehicleTypeSelect?: any;
    vehicleUFSelect?: any;
    ownerUFSelect?: any;
    merchandiseUnitySelect?: any;
    
    id?: number;
    companyId?: number;
    plantId?: number;
    mvmId?: number;
    origin?: string;
    type?: string;
    documentNumber?: string;
    documentSeriesNumber?: string;
    loadingUFCode?: any;
    loadingCityCode?: any;
    unloadingUFCode?: string;
    merchandiseTotalValue?: number;
    merchandiseUnityCode?: string;
    merchandiseTotalWeight?: number;
    observation?: string;
    vehiclePlateNumber?: string;
    vehicleType?: string;
    flagOwnVehicle?: boolean;
    tare?: number;
    renavam?: string;
    vehicleUFCode?: string;
    cargoCapacity?: number;
    ownerCNPJ?: string;
    ownerRNTC?: string;
    ownerCorporateName?: string;
    ownerIE?: string;
    ownerUFCode?: string;
    loadingUFAcronym?: string;
    unloadingUFAcronym?: string;
    vehicleUFAcronym?: string;
    issuerUFCode?: string;
    issuerUFAcronym?: string;
    issuerCNPJ?: string;
    issuerIE?: string;
    issuerCorporateName?: string;
    issuerPublicPlace?: string;
    issuerNumber?: string;
    issuerNeighborhood?: string;
    issuerCityCode?: string;
    issuerCityName?: string;
    loadingCityName?: string;
    ownerUFAcronym?: string;
    activateWorkflowAction?: string;
    mdfeSituation?: string;
    seriesNumber?: string;
    descriptionType?: string;
    createdAt?: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    vehicleId?: number;
    mdfeShipping: {
        mdfeId?: number;
        companyId?: number;
        mdfeStatus?: string;
        numericCode?: string;
        mdfeKeyDescription?: string;
        shippingContentDescription?: string;
        issueDate?: string;
        updatedAt?: string;
        issueStatusMDFe?: string;
        protocolNumber?: string;
        protocolStatus?: string;
        protocolMessage?: string;
        protocolNumberSEFAZ?: string;
        protocolStatusSEFAZ?: string;
        sEFAZMessage?: string;
        eventShippingContentDescription?: string;
        eventStatusMDFe?: string;
        eventTypeCode?: string;
        batchIdNumber?: number;
        eventSequencialNumber?: number;
        eventProtocolNumber?: string;
        eventProtocolStatus?: string;
        eventProtocolMessage?: string;
        eventProtocolStatusSEFAZ?: string;
        eventMessageSEFAZ?: string;
        fileName?: string;
        mensagemErroMDFe?: string;
    };
    mdfeConductors?: [
        {
            mdfeId: number;
            conductorName: string;
            conductorCPF: string;
        }
    ];
    mdfeUnloadings?: [
        {
            mdfeId: number;
            ufCode: string;
            cityCode: string;
            ufAcronym: string;
            cityName: string;
        }
    ];
    mdfeInvoices?: [
        {
            mdfeId: number;
            invoiceKeyNumber: string;
            invoiceType: string;
            totalValue: number;
            totalWeight: number;
        }
    ];
    mdfeRoutes?: [
        {
            mdfeId: number;
            uFCode: string;
            uFAcronym: string;
            orderNumber: number;
        }
    ]
}

const MDFeDetail: React.FC<Props> = (props) => {
    const classes = useStyles();
    const [mdfeData, setMdfeData] = useState<MDFe>({} as MDFe);
    const [mdfeUnloadings, setMDFeUnloadings] = useState<MDFeUnloading[] | any>();
    const [mdfeRoutes, setMDFeRoutes] = useState<MDFeRoute[] | any>();
    const [mdfeConductors, setMDFeConductors] = useState<MDFeConductor[] | any>();
    const [mdfeInvoices, setMDFeInvoices] = useState<MDFeInvoice[] | any>();
    const [loading, setLoading] = useState(true);
    const [canEdit, setCanEdit] = useState(true);
    const [saveVehicle, setSaveVehicle] = useState(true);
    const { t } = props.traduction;
    const { t: tGeneral } = useTranslation("General")
    const { t: tValidation } = useTranslation("Validation")
    const { enqueueSnackbar } = useSnackbar();
    const { user } = useAuth();
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [listMerchandiseUnityCode, setListMerchandiseUnityCode] = useState<any[]>([]);
    const [listUFs, setListUFs] = useState<any[]>([]);
    const [listCities, setListCities] = useState<any[]>([]);
    const [listCitiesUnloading, setListCitiesUnloading] = useState<any[]>([]);
    const [listVehicleTypes, setListVehicleTypes] = useState<any[]>([]);
    const [errorNewConductorCPF, setErrorNewConductorCPF] = useState(false);
    const [errorNewInvoice, setErrorNewInvoice] = useState(false);
    const {clickHandlerCalbkack, clickHandlerClose} = props;
    const [loadingVehicle, setLoadingVehicle] = useState(false);
    const company = Company.find((company: any) => company.companyID === user.company.companyID);

    const { handleSubmit, reset, control, getValues, setValue, setError, resetField } = useForm<IFormInput>(
        {
            defaultValues : {
                companyId: Number(user.company.companyID),
                plantId: Number(user.company.plantID),
                issuerCorporateName: user.company.companyName,
                issuerCNPJ: company && company.numberCnpj !== null ? company.numberCnpj : "",
                issuerIE: company && company.stateRegistration != null ? company.stateRegistration : "",
                issuerPublicPlace: company && company.address != null ?  company?.address : "",
                issuerCityName: company && company.locality != null ? company?.locality : "",
                issuerUFAcronym: company && company.region != null ?  company?.region : "",
                issuerUFCode: company && company.issuerUFCode != null ?  company?.issuerUFCode : "",
                issuerNumber: company && company.issuerNumber != null ?  company?.issuerNumber : "",
                issuerNeighborhood: company && company.issuerNeighborhood != null ?  company?.issuerNeighborhood : "",
                issuerCityCode: company && company.issuerCityCode != null ?  company?.issuerCityCode : "",
                
                loadingUFSelect: {},
                loadingCitySelect: {},
                unloadingUFSelect: {},
                vehicleTypeSelect: {},
                vehicleUFSelect: {},
                ownerUFSelect: {},
                merchandiseUnitySelect: {},
                newUFUnloading:{},
                newCityUnloading:{},
                newUFRoute: '',
                newConductorCPF: '',
                newConductorName: '',
                newInvoiceKey: '',

                id: 0,
                origin: '', // remover
                type: 'E',
                documentNumber: '',
                documentSeriesNumber: '',
                flagOwnVehicle: false,
                unloadingUFCode: '',
                merchandiseTotalValue: 0,
                merchandiseUnityCode: '',
                merchandiseTotalWeight: 0,
                observation: t('constAditionalInfo'),
                vehiclePlateNumber: '',
                vehicleType: '',
                tare: 0,
                renavam: '',
                vehicleUFCode: '',
                cargoCapacity: 0,
                ownerCNPJ: '',
                ownerRNTC: '',
                ownerCorporateName: '',
                ownerIE: '',
                ownerUFCode: '',
                loadingUFCode: '',
                loadingUFAcronym: '',
                unloadingUFAcronym: '',
                vehicleUFAcronym: '',
                loadingCityName: '',
                ownerUFAcronym: '',
                activateWorkflowAction: '',
                mdfeSituation: '',
                seriesNumber: '',
                descriptionType: '',
                updatedBy: '',
                mdfeShipping: {
                    mdfeId: 0,
                    companyId: 0,
                    mdfeStatus: '',
                    numericCode: undefined,
                    mdfeKeyDescription: undefined,
                    shippingContentDescription: undefined,
                    issueDate: undefined,
                    updatedAt: '',
                    issueStatusMDFe: undefined,
                    protocolNumber: undefined,
                    protocolStatus: undefined,
                    protocolMessage: undefined,
                    protocolNumberSEFAZ: undefined,
                    protocolStatusSEFAZ: undefined,
                    sEFAZMessage: undefined,
                    eventShippingContentDescription: undefined,
                    eventStatusMDFe: undefined,
                    eventTypeCode: undefined,
                    batchIdNumber: undefined,
                    eventSequencialNumber: undefined,
                    eventProtocolNumber: undefined,
                    eventProtocolStatus: undefined,
                    eventProtocolMessage: undefined,
                    eventProtocolStatusSEFAZ: undefined,
                    eventMessageSEFAZ: undefined,
                    fileName: undefined,
                    mensagemErroMDFe: ''
                },
                mdfeConductors: mdfeConductors,
                mdfeUnloadings: mdfeUnloadings,
                mdfeInvoices: mdfeInvoices,
                mdfeRoutes: mdfeRoutes,
            }
    })

    const onSubmit = async (data: any) => {
        try {
            setValue('origin', '-');

            setValue('loadingCityCode', getValues().loadingCitySelect.code);
            setValue('loadingCityName', getValues().loadingCitySelect.label);

            setValue('loadingUFCode', getValues().loadingUFSelect.code);
            setValue('loadingUFAcronym', getValues().loadingUFSelect.label);

            setValue('loadingCityCode', getValues().loadingCitySelect.code);
            setValue('loadingCityName', getValues().loadingCitySelect.label);


            setValue('unloadingUFCode', getValues().unloadingUFSelect.code);
            setValue('unloadingUFAcronym', getValues().unloadingUFSelect.label);

            setValue('vehicleType', getValues().vehicleTypeSelect.code);

            setValue('vehicleUFCode', getValues().vehicleUFSelect.code);
            setValue('vehicleUFAcronym', getValues().vehicleUFSelect.label);

            setValue('ownerUFCode', getValues().ownerUFSelect.code);
            setValue('ownerUFAcronym', getValues().ownerUFSelect.label);
 
            setValue('merchandiseUnityCode', getValues().merchandiseUnitySelect.code);

            setValue('mdfeUnloadings', mdfeUnloadings);
            setValue('mdfeRoutes', mdfeRoutes);
            setValue('mdfeConductors', mdfeConductors);
            setValue('mdfeInvoices', mdfeInvoices);

            let mdfeShipping = {
                mdfeId: 0,
                companyId: 0,
                mdfeStatus: '',
                numericCode: undefined,
                mdfeKeyDescription: undefined,
                shippingContentDescription: undefined,
                issueDate: undefined,
                updatedAt: '',
                issueStatusMDFe: undefined,
                protocolNumber: undefined,
                protocolStatus: undefined,
                protocolMessage: undefined,
                protocolNumberSEFAZ: undefined,
                protocolStatusSEFAZ: undefined,
                sEFAZMessage: undefined,
                eventShippingContentDescription: undefined,
                eventStatusMDFe: undefined,
                eventTypeCode: undefined,
                batchIdNumber: undefined,
                eventSequencialNumber: undefined,
                eventProtocolNumber: undefined,
                eventProtocolStatus: undefined,
                eventProtocolMessage: undefined,
                eventProtocolStatusSEFAZ: undefined,
                eventMessageSEFAZ: undefined,
                fileName: undefined,
                mensagemErroMDFe: ''
            }

            setValue('mdfeShipping', mdfeShipping);
            const mdfe = getValues();

            //delete mdfe.createdAt
            //delete mdfe.createdBy
            delete mdfe.descriptionType
            delete mdfe.mdfeSituation
            delete mdfe.seriesNumber
            delete mdfe.updatedAt

            const schema = Yup.object().shape({
                loadingUFCode: Yup.string()
                    .max(2, t("maxInput2"))
                    .required(t("requiredField")),
                loadingCityCode: Yup.string()
                    .max(7, t("maxInput7"))
                    .required(t("requiredField")),
                unloadingUFCode: Yup.string()
                    .max(2, t("maxInput2"))
                    .required(t("requiredField")),
                vehiclePlateNumber: Yup.string()
                    .max(7, t("maxInput7"))
                    .required(t("requiredField")),
                vehicleType: Yup.string()
                    .max(2, t("maxInput2"))
                    .required(t("requiredField")),
                flagOwnVehicle: Yup.boolean()
                    .required(t("requiredField")),
                tare: Yup.number()
                    .typeError(t("mustBeNumber"))
                    .required(t("requiredField")),
                vehicleUFCode: Yup.string()
                    .required(t("requiredField")),
                cargoCapacity: Yup.number()
                    .typeError(t("mustBeNumber"))
                    .required(t("requiredField")),
                ownerCNPJ: Yup.string()
                    .max(14, t("maxInput14")),
                ownerRNTC: Yup.string()
                    .max(8, t("maxInput8")),
                ownerCorporateName: Yup.string()
                    .max(60, t("maxInput60")),
                ownerIE: Yup.string()
                    .max(14, t("maxInput14")),
                ownerUFCode: Yup.string()
                    .max(2, t("maxInput2")),
                merchandiseTotalValue: Yup.number()
                    .typeError(t("mustBeNumber"))
                    .required(t("requiredField")),
                merchandiseTotalWeight: Yup.number()
                    .typeError(t("mustBeNumber"))
                    .required(t("requiredField")),
                merchandiseUnityCode: Yup.string()
                    .max(2, t("maxInput2"))
                    .required(t("requiredField"))
            });

            await schema.validate(mdfe, {
                abortEarly: false,
            });

            if (!mdfe.observation?.includes(t('constAditionalInfo')))
                setValue('observation',t('constAditionalInfo') + ' ' +  mdfe.observation);

            setOpenBackdrop(true);
            
            if (saveVehicle){
                const vehicleData: any  = {
                    vehiclePlateNumber: mdfe?.vehiclePlateNumber,
                    cartPlateNumber: "",
                    vehicleManufacturer: "-",
                    vehicleType: mdfe?.vehicleType,
                    companyId: +user.company.companyID,
                    plantId: +user.company.plantID,
                    tareVehicle: mdfe?.tare,
                    renavam: mdfe?.renavam,
                    ufRegistration: mdfe?.vehicleUFAcronym,
                    loadCapacity: mdfe?.cargoCapacity,
                    cpF_CNPJ_Owner: mdfe?.ownerCNPJ,
                    rntCOwner: mdfe?.ownerRNTC,
                    corporateNameOwner: mdfe?.ownerCorporateName,
                    iEOwner: mdfe?.ownerIE,
                    uFOwner: mdfe?.ownerUFAcronym,
                    id: mdfe?.vehicleId
                }

                let vehicleDataItem:VehiclePost = vehicleData;

                if (vehicleDataItem.id === undefined || vehicleDataItem.id === 0){
                    VehicleApi.postVehicle(vehicleDataItem)
                } else {
                    VehicleApi.putVehicle(vehicleDataItem)
                }
            }
            
            if (mdfe.id && mdfe.id > 0) {
                mdfe.updatedBy = user.name

                MDFeApi.putMDFe(mdfe)
                    .then(result => {
                        enqueueSnackbar(t("returnSubmitEditFormSuccess"), { variant: 'success' });
                        clickHandlerCalbkack();
                        clickHandlerClose();
                    }).finally(() => {
                        setOpenBackdrop(false);
                    });
            }
            else {
                mdfe.createdBy = user.name
                mdfe.updatedBy = user.name
                mdfe.companyId = Number(user.company.companyID)
                mdfe.plantId = Number(user.company.plantID)

                MDFeApi.postMDFe(mdfe as MDFePost)
                    .then(result => {
                        enqueueSnackbar(t("returnSubmitFormSuccess"), { variant: 'success' });
                        setMdfeData(result)
                        clickHandlerCalbkack();
                        clickHandlerClose();
                    }).finally(() => {
                        setOpenBackdrop(false);
                    });
            }
            

        } catch (err) {
            const errors: string[] = []

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {

                    if (errors.filter(element => element.includes(error.message)).length === 0)
                        errors.push(error.message)

                    setError(error.path?.split('.')[0] as 
                    "tare" 
                    , { message: error.message });
                })

                errors.forEach(element => { 
                    if (element === tValidation("requiredField"))
                        enqueueSnackbar(tGeneral("requiredFieldsValidation"), { variant: 'warning' }) 
                    else    
                        enqueueSnackbar(element, { variant: 'warning' }) 
                })
            }

            //result = false;

        }
    }
    
    useEffect(() => {
        setLoading(false);
        getListMerchandiseUnityCode();
        getListUFs();
        getListVehicleTypes();

        if (props.mdfeId > 0) {
            getMDFeDetails(props.mdfeId);
        }
        else {
            initNewMDFe();
        }
    }, [props.mdfeId]);

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: mdfeData && mdfeData.mdfeUnloadings && mdfeData.mdfeUnloadings.length > 0 ? 'pointer' : ''
                }
            }
        }
    })
    
    const columnsUnloadings = [
        {
            name: 'ufAcronym',
            label: t('uf'),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: 'cityName',
            label: t('city'),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: "",
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <AlertDialog
                            dialogTitle={t("dialogDeleteTitle")}
                            dialogContentText={t("dialogDeleteContentText")}
                            cancelTextButton={t("cancelDeleteTextButton")}
                            confirmTextButton={t("confirmDeleteTextButton")}
                            confirmDialogFunction={() => { handleDeleteUnloadingItem(tableMeta.rowData[1]); }}
                            Button={
                                <IconButton size='small' edge="end">
                                    <DeleteIcon />
                                </IconButton>
                            }
                        />
                    );
                }
            }
        }
    ]

    const columnsRoutes = [
        {
            name: 'orderNumber',
            label: '#',
            options: {
                setCellHeaderProps: () => ({ align: "center" }),
                setCellProps: () => ({ align: "center" })
            }
        },
        {
            name: 'ufAcronym',
            label: t('uf'),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: "",
            options: {
                setCellProps: () => ({
                    align: "right",

                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <AlertDialog
                            dialogTitle={t("dialogDeleteTitle")}
                            dialogContentText={t("dialogDeleteContentText")}
                            cancelTextButton={t("cancelDeleteTextButton")}
                            confirmTextButton={t("confirmDeleteTextButton")}
                            confirmDialogFunction={() => { handleDeleteRouteItem(tableMeta.rowData[1]); }}
                            Button={
                                <IconButton size='small' edge="end">
                                    <DeleteIcon />
                                </IconButton>
                            }
                        />
                    );
                }
            }
        }
    ]

    const columnsConductors = [
        {
            name: 'conductorName',
            label: t('name'),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: 'conductorCPF',
            label: t('cpf'),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: "",
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <AlertDialog
                            dialogTitle={t("dialogDeleteTitle")}
                            dialogContentText={t("dialogDeleteContentText")}
                            cancelTextButton={t("cancelDeleteTextButton")}
                            confirmTextButton={t("confirmDeleteTextButton")}
                            confirmDialogFunction={() => { handleDeleteConductorItem(tableMeta.rowData[0]); }}
                            Button={
                                <IconButton size='small' edge="end">
                                    <DeleteIcon />
                                </IconButton>
                            }
                        />
                    );
                }
            }
        }
    ]

    const columnsInvoices = [
        {
            name: 'invoiceKeyNumber',
            label: t('name'),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: "",
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <AlertDialog
                            dialogTitle={t("dialogDeleteTitle")}
                            dialogContentText={t("dialogDeleteContentText")}
                            cancelTextButton={t("cancelDeleteTextButton")}
                            confirmTextButton={t("confirmDeleteTextButton")}
                            confirmDialogFunction={() => { handleDeleteInvoiceItem(tableMeta.rowData[0]); }}
                            Button={
                                <IconButton size='small' edge="end">
                                    <DeleteIcon />
                                </IconButton>
                            }
                        />
                    );
                }
            }
        }
    ]

    const options = {
        textLabels: {
            body: {
                noMatch: 'Nenhum registro para exibir',
                toolTip: "",
            },
            pagination: {
                next: "Proxima",
                previous: "Anterior",
                rowsPerPage: "Linhas por pagina:",
                displayRows: "de",
            }
        }
    }

    const getMDFeDetails = (mdfeId: number) => {
        
        setLoading(true);

        Promise.all([MDFeApi.getMDFeDetails(mdfeId), VehicleTypeApi.searchAll()]).then(([result, vehicleTypes]) => {

            if (result) {
                setMdfeData(result);

                const vehicleTypeDescription = vehicleTypes?.find((vt: any) => vt.code === result.vehicleType)?.description || result.vehicleType;

                reset({
                    companyId: Number(user.company.companyID),
                    plantId: Number(user.company.plantID),
                    issuerCorporateName: user.company.companyName,
                    issuerCNPJ: company && company.numberCnpj !== null ? company.numberCnpj : "",
                    issuerIE: company && company.stateRegistration != null ? company.stateRegistration : "",
                    issuerPublicPlace: company && company.address != null ?  company?.address : "",
                    issuerCityName: company && company.locality != null ? company?.locality : "",
                    issuerUFAcronym: company && company.region != null ?  company?.region : "",
                    issuerUFCode: company && company.issuerUFCode != null ?  company?.issuerUFCode : "",
                    issuerNumber: company && company.issuerNumber != null ?  company?.issuerNumber : "",
                    issuerNeighborhood: company && company.issuerNeighborhood != null ?  company?.issuerNeighborhood : "",
                    issuerCityCode: company && company.issuerCityCode != null ?  company?.issuerCityCode : "",
                    
                    id: result.id,
                    origin: result.origin,
                    type: result.type,
                    documentNumber: result.documentNumber,
                    documentSeriesNumber: result.documentSeriesNumber,
                    flagOwnVehicle: result.flagOwnVehicle,
                    merchandiseTotalValue: result.merchandiseTotalValue,
                    merchandiseUnityCode: result.merchandiseUnityCode,
                    merchandiseTotalWeight: result.merchandiseTotalWeight,
                    observation: result.observation,
                    vehiclePlateNumber: result.vehiclePlateNumber,
                    vehicleType: result.vehicleType,
                    tare: result.tare,
                    renavam: result.renavam,
                    vehicleUFCode: result.vehicleUFCode,
                    cargoCapacity: result.cargoCapacity,
                    ownerCNPJ: result.ownerCNPJ,
                    ownerRNTC: result.ownerRNTC,
                    ownerCorporateName: result.ownerCorporateName,
                    ownerIE: result.ownerIE,
                    ownerUFCode: result.ownerUFCode,
                    unloadingUFAcronym: result.unloadingUFAcronym,
                    vehicleUFAcronym: result.vehicleUFAcronym,
                    loadingCityName: result.loadingCityName,
                    ownerUFAcronym: result.ownerUFAcronym,
                    activateWorkflowAction: result.activateWorkflowAction,
                    mdfeSituation: result.mdfeSituation,
                    seriesNumber: result.seriesNumber,
                    descriptionType: result.descriptionType,
                    updatedBy: result.updatedBy,
                    loadingUFSelect: { code: result.loadingUFCode, label: result.loadingUFAcronym },
                    loadingCitySelect : { code: result.loadingCityCode, label: result.loadingCityName },
                    unloadingUFSelect: { code: result.unloadingUFCode, label: result.unloadingUFAcronym },
                    vehicleTypeSelect: { code: result.vehicleType, label: vehicleTypeDescription },
                    vehicleUFSelect: {code: result.vehicleUFCode, label: result.vehicleUFAcronym },
                    ownerUFSelect: {code: result.ownerUFCode, label: UF.find((item: any) => item.COD_UF === result.ownerUFCode)?.SIGLA_UF },
                    merchandiseUnitySelect: {code: result.merchandiseUnityCode, label: MDFE_UNIDADE_MEDIDA.find((item: any) => item.code === result.merchandiseUnityCode)?.label },
                    createdBy: result.createdBy,
                    createdAt: result.createdAt
                })

                setMDFeUnloadings(result.mdfeUnloadings)
                setMDFeRoutes(result.mdfeRoutes)
                setMDFeConductors(result.mdfeConductors)
                setMDFeInvoices(result.mdfeInvoices)
                getListCities(result.loadingUFCode)
                setCanEdit(result.mdfeSituation === "RAS")
            }

        }).catch((error: any) => {
        }).finally(() => {
            setLoading(false);
        });
    }

    const initNewMDFe = async () => {

        let mdfe: MDFe = {
                companyId: Number(user.company.companyID),
                plantId: Number(user.company.plantID),
                issuerCorporateName: user.company.companyName,
                issuerCNPJ: company && company.numberCnpj !== null ? company.numberCnpj : "",
                issuerIE: company && company.stateRegistration != null ? company.stateRegistration : "",
                issuerPublicPlace: company && company.address != null ?  company?.address : "",
                issuerCityName: company && company.locality != null ? company?.locality : "",
                issuerUFAcronym: company && company.region != null ?  company?.region : "",
                issuerUFCode: company && company.issuerUFCode != null ?  company?.issuerUFCode : "",
                issuerNumber: company && company.issuerNumber != null ?  company?.issuerNumber : "",
                issuerNeighborhood: company && company.issuerNeighborhood != null ?  company?.issuerNeighborhood : "",
                issuerCityCode: company && company.issuerCityCode != null ?  company?.issuerCityCode : "",

                origin: '', // remover
                type: 'E',
                documentNumber: '',
                documentSeriesNumber: '',
                flagOwnVehicle: false,
                unloadingUFCode: '',
                merchandiseTotalValue: 0,
                merchandiseUnityCode: '',
                merchandiseTotalWeight: 0,
                observation: t('constAditionalInfo'),
                vehiclePlateNumber: '',
                vehicleType: '',
                tare: 0,
                renavam: '',
                vehicleUFCode: '',
                cargoCapacity: 0,
                ownerCNPJ: '',
                ownerRNTC: '',
                ownerCorporateName: '',
                ownerIE: '',
                ownerUFCode: '',
                loadingUFAcronym: '',
                unloadingUFAcronym: '',
                vehicleUFAcronym: '',
                loadingCityCode: '',
                loadingCityName: '',
                ownerUFAcronym: '',
                activateWorkflowAction: '',
                mdfeSituation: '',
                seriesNumber: '',
                descriptionType: '',
                updatedBy: '',
                mdfeShipping: {
                    mdfeId: 0,
                    companyId: 0,
                    mdfeStatus: '',
                    numericCode: undefined,
                    mdfeKeyDescription: undefined,
                    shippingContentDescription: undefined,
                    issueDate: undefined,
                    updatedAt: '',
                    issueStatusMDFe: undefined,
                    protocolNumber: undefined,
                    protocolStatus: undefined,
                    protocolMessage: undefined,
                    protocolNumberSEFAZ: undefined,
                    protocolStatusSEFAZ: undefined,
                    sEFAZMessage: undefined,
                    eventShippingContentDescription: undefined,
                    eventStatusMDFe: undefined,
                    eventTypeCode: undefined,
                    batchIdNumber: undefined,
                    eventSequencialNumber: undefined,
                    eventProtocolNumber: undefined,
                    eventProtocolStatus: undefined,
                    eventProtocolMessage: undefined,
                    eventProtocolStatusSEFAZ: undefined,
                    eventMessageSEFAZ: undefined,
                    fileName: undefined,
                    mensagemErroMDFe: ''
                },
                mdfeConductors: mdfeConductors,
                mdfeUnloadings: mdfeUnloadings,
                mdfeInvoices: mdfeInvoices,
                mdfeRoutes: mdfeRoutes,
            }

            setMdfeData(mdfe)
            setMDFeUnloadings([])
            setMDFeRoutes([])
            setMDFeConductors([])
            setMDFeInvoices([])
    }

    const getListMerchandiseUnityCode = () => {
        setListMerchandiseUnityCode(MDFE_UNIDADE_MEDIDA);
    }

    const getListVehicleTypes = () => {

        VehicleTypeApi.searchAll().then((result) => {

            if (result) {
                setListVehicleTypes(result.map(
                    (vehicleType: any) => ({
                        code: vehicleType.code, label: vehicleType.description
                    })));
            }
            else {
                setListVehicleTypes([]);
            }

        }).catch(() => {
            setListVehicleTypes([]);
        });

    }

    const getListUFs = () => {
                setListUFs(UF.map(
                    (uf: any) => ({
                        code: uf.COD_UF, label: uf.SIGLA_UF
                    })));
    }

    const getListCities = (uf: string) => {
        const cities = city.filter((city: any) => city.COD_UF === uf);

        setListCities(cities.map(
            (city: any) => ({
                code: city.COD_MUNICIPIO, label: city.NOME_MUNICIPIO
            }))
        );
    }

    const getListCitiesUnloading = (uf: string) => {
        const cities = city.filter((city: any) => city.COD_UF === uf);

        setListCitiesUnloading(cities.map(
            (city: any) => ({
                code: city.COD_MUNICIPIO, label: city.NOME_MUNICIPIO
            }))
        );
    }

    function handleDeleteUnloadingItem(city: string) {
        let unloadings = mdfeUnloadings.filter((item: MDFeUnloading) => item.cityName !== city)

        setMDFeUnloadings(unloadings);
    }

    function handleDeleteRouteItem(uf: string) {
        let routes = mdfeRoutes.filter((item: MDFeRoute) => item.ufAcronym !== uf)

        routes.forEach((item: MDFeRoute, index: number) => {
            item.orderNumber = index + 1
        });

        setMDFeRoutes(routes);
    }

    function handleDeleteConductorItem(name: string) {
        let conductors = mdfeConductors.filter((item: MDFeConductor) => item.conductorName !== name)

        setMDFeConductors(conductors);
    }

    function handleDeleteInvoiceItem(invoiceKey: string) {
        let invoices = mdfeInvoices.filter((item: MDFeInvoice) => item.invoiceKeyNumber !== invoiceKey)

        setMDFeInvoices(invoices);
    }

    function handleIncludeUnloading() {
       
        const { newUFUnloading, newCityUnloading } = getValues();

        if ((mdfeUnloadings && mdfeUnloadings.find((item: MDFeUnloading) => item.cityCode === newCityUnloading.label))
            || !newUFUnloading || !newCityUnloading) {
            return
        }

        let unloading: MDFeUnloading =
        {
            mdfeId: mdfeData.id,
            ufCode: `${newUFUnloading.code}`,
            cityCode: `${newCityUnloading.code}`,
            ufAcronym: `${newUFUnloading.label}`,
            cityName: `${newCityUnloading.label}`
        }

        setMDFeUnloadings([unloading, ...mdfeUnloadings]);
        resetField('newUFUnloading');
        resetField('newCityUnloading');
    }

    function handleIncludeRoute() {

        const { newUFRoute } = getValues();

        if ((mdfeRoutes && mdfeRoutes.find((item: MDFeRoute) => item.ufCode === newUFRoute.code))
            || !newUFRoute) {
            return
        }

        let route: MDFeRoute =
        {
            mdfeId: mdfeData.id,
            ufCode: `${newUFRoute.code}`,
            ufAcronym: `${newUFRoute.label}`,
            orderNumber: mdfeRoutes.length + 1
        }

        setMDFeRoutes([...mdfeRoutes, route]);
        resetField('newUFRoute');
    }

    function handleIncludeConductor() {

        const { newConductorCPF, newConductorName } = getValues();

        if ((mdfeConductors && mdfeConductors.find(
            (item: MDFeConductor) => item.conductorName === newConductorName
                && item.conductorCPF === newConductorCPF
        ))
            || !newConductorName || !newConductorCPF) {
            return
        }

        setErrorNewConductorCPF(false);

        let conductor: MDFeConductor =
        {
            mdfeId: mdfeData.id,
            conductorCPF: newConductorCPF,
            conductorName: newConductorName
        }

        setMDFeConductors([conductor, ...mdfeConductors]);

        resetField('newConductorName');
        resetField('newConductorCPF');
    }

    function handleIncludeInvoice() {
        const { newInvoiceKey } = getValues();

        if ((mdfeInvoices && mdfeInvoices.find((item: MDFeInvoice) => item.invoiceKeyNumber === newInvoiceKey)) || !newInvoiceKey)
            return

        if (newInvoiceKey.length !== 44) {
            setErrorNewInvoice(true)
            return
        }

        setErrorNewInvoice(false)

        let invoice: MDFeInvoice =
        {
            mdfeId: mdfeData.id,
            invoiceKeyNumber: newInvoiceKey,
            invoiceType: "NFE"
        }

        setMDFeInvoices([invoice, ...mdfeInvoices]);

        resetField('newInvoiceKey');
    }

    const handleCancelMDFe = () => {
        if (!mdfeData.id)
            return;

        setOpenBackdrop(true);

        MDFeApi.cancelMDFe(mdfeData.id).then((result) => {

            if (result) {
                setMdfeData(result);
                setMDFeUnloadings(result.mdfeUnloadings)
                setMDFeRoutes(result.mdfeRoutes)
                setMDFeConductors(result.mdfeConductors)
                setMDFeInvoices(result.mdfeInvoices)
                setCanEdit(result.mdfeSituation === "RAS")
            }
            else {
                setMdfeData({} as MDFe);
            }

            enqueueSnackbar(t("returnCancelMDFe"), { variant: 'success' });

        }).catch(() => {
            setMdfeData({} as MDFe);
        }).finally(() => {
            setOpenBackdrop(false);
        });

    }

    const handleTerminateMDFe = () => {
        if (!mdfeData.id)
            return;

        setOpenBackdrop(true)

        MDFeApi.terminateMDFe(mdfeData.id).then((result) => {

            if (result) {
                setMdfeData(result);
                setMDFeUnloadings(result.mdfeUnloadings)
                setMDFeRoutes(result.mdfeRoutes)
                setMDFeConductors(result.mdfeConductors)
                setMDFeInvoices(result.mdfeInvoices)
                setCanEdit(result.mdfeSituation === "RAS")
            }
            else {
                setMdfeData({} as MDFe);
            }

            enqueueSnackbar(t("returnTerminateMDFe"), { variant: 'success' });

        }).catch(() => {
            setMdfeData({} as MDFe);
        }).finally(() => {
            setOpenBackdrop(false);
        });

    }

    const handleSearchVehicle = async(vehiclePlateNumber: any) => {
        
        if (!vehiclePlateNumber || vehiclePlateNumber.length < 7 || vehiclePlateNumber.includes('_'))
            return;

        let params : VehicleSearch = {
            VehiclePlateNumber: vehiclePlateNumber
        }
        setLoadingVehicle(true)
        mdfeData.vehicleId = 0;
        await VehicleApi.searchVehicle(params)
        .then(result => {
            if (result.items.length > 0) {
                var item = result.items[0]

                var mdfeDataAux = mdfeData
                mdfeDataAux.vehicleType =  item.vehicleType
                mdfeDataAux.flagOwnVehicle =  item.flagOwnVehicle
                mdfeDataAux.tare = item.tareVehicle
                mdfeDataAux.renavam = item.renavam

                let itemUfRegistration = item.ufRegistration;
                let ufRegistration = UF.find((item: any) => item.SIGLA_UF === itemUfRegistration);
                mdfeDataAux.vehicleUFCode = ufRegistration?.COD_UF;
                mdfeDataAux.vehicleUFAcronym = ufRegistration?.SIGLA_UF;

                mdfeDataAux.cargoCapacity =item.loadCapacity
                mdfeDataAux.ownerCNPJ = item.cpF_CNPJ_Owner
                mdfeDataAux.ownerRNTC = item.rntcOwner
                mdfeDataAux.ownerCorporateName = item.corporateNameOwner
                mdfeDataAux.ownerIE = item.ieOwner

                let itemUfOwner = item.ufOwner;
                let ufOwner = UF.find((item: any) => item.SIGLA_UF === itemUfOwner);
                mdfeDataAux.ownerUFCode = ufOwner?.COD_UF;
                mdfeDataAux.ownerUFAcronym = ufOwner?.SIGLA_UF;

                mdfeDataAux.vehicleId = item.id
  
                setMdfeData(mdfeDataAux);
                
                setValue('vehicleId', item.id);
                setValue('vehicleTypeSelect', {code: item.vehicleType, label: item?.vehicleTypeDescription });
                setValue('flagOwnVehicle', item.flagOwnVehicle);
                setValue('tare', item.tareVehicle);
                setValue('renavam', item.renavam);
                setValue('vehicleUFSelect', {code: ufRegistration?.COD_UF, label: ufRegistration?.SIGLA_UF });
                setValue('cargoCapacity', item.loadCapacity);
                setValue('ownerCNPJ', item.cpF_CNPJ_Owner);
                setValue('ownerRNTC', item.rntcOwner);
                setValue('ownerCorporateName', item.corporateNameOwner);
                setValue('ownerIE', item.ieOwner);
                setValue('ownerUFSelect', {code: ufOwner?.COD_UF, label: ufOwner?.SIGLA_UF });

                setSaveVehicle(true);
            }
        }).finally(() => setLoadingVehicle(false) );
    }  

    return (
        <Container maxWidth={false} component="main">

            {
                loading ?
                    <LoadingUI />
                    :
                    <React.Fragment>

                        <Backdrop className={classes.backdrop} open={openBackdrop}>
                            <CircularProgress color="inherit" />
                        </Backdrop>
                        
                        <form onSubmit={handleSubmit(onSubmit)} >

                            <Grid container spacing={1}>
                                <Grid item xs={3}>
                                    {props.mdfeId > 0 && (
                                        <PageTitle title={`${t("MDFeDetail")} - ${mdfeData.seriesNumber}`} style={{ marginLeft: "40px" }} />
                                    )}
                                    <If test={props.mdfeId === 0}>
                                        <PageTitle title={`${t("IncludeMDFe")}`} style={{ marginLeft: "40px" }} />
                                    </If>
                                </Grid>

                                <Grid item xs={9}>
                                    <div className={classes.mdfeActions}>
                                        <AlertDialog
                                            dialogTitle={t("dialogConfirmTitle")}
                                            dialogContentText={t("dialogConfirmContentText")}
                                            cancelTextButton={t("cancelConfirmTextButton")}
                                            confirmTextButton={t("confirmSaveButton")}
                                            confirmDialogFunction={onSubmit}
                                            Button={
                                                <ButtonUI
                                                    startIcon={<SaveIcon />}
                                                    color="primary"
                                                    disabled={!canEdit}
                                                >
                                                    {t("save")}
                                                </ButtonUI>
                                            }
                                        />
                                        {props.mdfeId > 0 && (
                                            <>
                                            <AlertDialog
                                                dialogTitle={t("dialogTerminateTitle")}
                                                dialogContentText={t("dialogTerminateContentText")}
                                                cancelTextButton={t("cancelConfirmTextButton")}
                                                confirmTextButton={t("confirmTerminateButton")}
                                                confirmDialogFunction={handleTerminateMDFe}
                                                Button={
                                                    <ButtonUI
                                                        startIcon={<DoneAllIcon />}
                                                        color="secondary"
                                                        disabled={!canEdit || mdfeData.mdfeShipping === null}
                                                    >
                                                        {t("terminate")}
                                                    </ButtonUI>
                                                }
                                            />

                                            <AlertDialog
                                                dialogTitle={t("dialogCancelTitle")}
                                                dialogContentText={t("dialogCancelContentText")}
                                                cancelTextButton={t("cancelConfirmTextButton")}
                                                confirmTextButton={t("confirmCancelButton")}
                                                confirmDialogFunction={handleCancelMDFe}
                                                 Button={
                                                    <ButtonUI
                                                        startIcon={<CloseIcon />}
                                                        color="secondary"
                                                        disabled={!canEdit || mdfeData.mdfeShipping === null}
                                                    >
                                                        {t("cancel")}
                                                    </ButtonUI>
                                                }
                                            />
                                            </>
                                        )}
                                    </div>
                                </Grid>
                            </Grid>

                                <Grid container spacing={1}>
                                    {props?.mdfeId > 0 && (
                                        <>
                                            <Grid item xs={2}>
                                                <TextField                                                     
                                                    label={t("documentNumber")}
                                                    name="documentNumber"
                                                    fullWidth
                                                    InputProps={{
                                                        readOnly: true,
                                                        classes: {
                                                            input: classes.inputBlocked
                                                        }
                                                    }}
                                                    control={control}
                                                />
                                            </Grid>

                                            <Grid item xs={1}>
                                                <TextField
                                                    label={t("seriesNumber")}
                                                    name="seriesNumber"
                                                    className={classes.rootForm}
                                                    fullWidth
                                                    InputProps={{
                                                        readOnly: true,
                                                        classes: {
                                                            input: classes.inputBlocked
                                                        }
                                                    }}
                                                    control={control}
                                                />
                                            </Grid>
                                        </>
                                    )}

                                    <Grid item xs={3}>
                                        <TextField
                                             
                                            label={t("issuerCorporateName")}
                                            name="issuerCorporateName"
                                            className={classes.rootForm}
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                readOnly: true,
                                                classes: {
                                                    input: classes.inputBlocked,
                                                },
                                            }}
                                            control={control}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <TextField
                                            label={t("issuerCNPJ")}
                                            name="issuerCNPJ"
                                            className={classes.rootForm}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true,
                                                classes: {
                                                    input: classes.inputBlocked,
                                                },
                                            }}
                                            control={control}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <TextField
                                             
                                            label={t("issuerIE")}
                                            name="issuerIE"
                                            className={classes.rootForm}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true,
                                                classes: {
                                                    input: classes.inputBlocked,
                                                },
                                            }}
                                            control={control}
                                        />
                                    </Grid>

                                    <Grid item xs={4}>
                                        <TextField                                         
                                            label={t("issuerPublicPlace")}
                                            name="issuerPublicPlace"
                                            className={classes.rootForm}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true,
                                                classes: {
                                                    input: classes.inputBlocked,
                                                },
                                            }}
                                            control={control}
                                        />
                                    </Grid>

                                </Grid>

                                <Grid container spacing={1}>
                                    <Grid item xs={2}>
                                        <TextField
                                            label={t("issuerCityName")}
                                            name="issuerCityName"
                                            className={classes.rootForm}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true,
                                                classes: {
                                                    input: classes.inputBlocked,
                                                },
                                            }}
                                            control={control}
                                        />
                                    </Grid>

                                    <Grid item xs={1}>
                                        <TextField
                                            label={t("issuerUFAcronym")}
                                            name="issuerUFAcronym"
                                            className={classes.rootForm}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true,
                                                classes: {
                                                    input: classes.inputBlocked,
                                                },
                                            }}
                                            control={control}
                                        />
                                    </Grid>

                                    <Grid item xs={2} >
                                        <Select
                                            label={t("loadingUFCode")}
                                            name="loadingUFSelect"
                                            required={true}
                                            className={classes.rootForm}
                                            options={listUFs}
                                            onChange={(item: any) => {
                                                getListCities(item.code as string);
                                            }}
                                            fullWidth
                                            control={control}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Select
                                            label={t("loadingCityCode")}
                                            name="loadingCitySelect"
                                            required={true}
                                            options={listCities}
                                            fullWidth
                                            control={control}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <Select
                                            label={t("unloadingUFCode")}
                                            name="unloadingUFSelect"
                                            required={true}
                                            options={listUFs}
                                            control={control}
                                        />
                                    </Grid>

                                </Grid>

                                <br />
                                <Divider />
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <PageTitle title={t("vehicleTitle")} />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={1}>

                                    <Grid item xs={2}>
                                        <TextField 
                                            label={t('vehiclePlateNumber')} 
                                            name="vehiclePlateNumber"
                                            mask="aaa9*99"
                                            required={true}
                                            fullWidth
                                            onChange={(e: any) => handleSearchVehicle(e.target.value)}
                                            control={control}
                                        />
                                    </Grid>
                                    {!loadingVehicle && 
                                        <>
                                    <Grid item xs={2}>
                                        <Select
                                            name="vehicleTypeSelect"
                                            required={true}
                                            label={t('vehicleType')}
                                            options={listVehicleTypes}
                                            control={control}
                                        />
                                    </Grid>

                                    <Grid item xs={1} style={{paddingLeft: '20px'}}>
                                    <Switch
                                        //disabled={mdfeData.flagOwnVehicle}
                                        label={t("flagOwnVehicle")}
                                        labelPlacement="top"
                                        name="flagOwnVehicle"
                                        control={control}
                                    />  

                                    </Grid>

                                    <Grid item xs={2}>
                                        <TextField
                                            label={t("tare")}
                                            name="tare"
                                            fullWidth
                                            control={control}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <TextField
                                            label={t("renavam")}
                                            name="renavam"
                                            type={"number"}
                                            required={true}
                                            className={classes.rootForm}
                                            fullWidth
                                            InputProps={{
                                                readOnly: !canEdit,
                                                classes: {
                                                    input: canEdit ? classes.input : classes.inputBlocked
                                                }
                                            }}
                                            control={control}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <If test={canEdit}>
                                            <Select
                                                name="vehicleUFSelect"
                                                required={true}
                                                label={t('vehicleUFCode')}
                                                options={listUFs}
                                                control={control}
                                            />
                                        </If>
                                        <If test={!canEdit}>
                                            <TextField
                                                label={t("vehicleUFCode")}
                                                name="vehicleUFCode"
                                                className={classes.rootForm}
                                                fullWidth
                                                InputProps={{
                                                    readOnly: true,
                                                    classes: {
                                                        input: classes.inputBlocked
                                                    }
                                                }}
                                                control={control}
                                            />
                                        </If>
                                    </Grid>
                                    </>
                                    }
                                </Grid>

                                <Grid container spacing={1}>
                                {!loadingVehicle && 
                                        <>
                                    <Grid item xs={2}>
                                        <TextField
                                            label={t("cargoCapacity")}
                                            name="cargoCapacity"
                                            type={"number"}
                                            className={classes.rootForm}
                                            fullWidth
                                            InputProps={{
                                                readOnly: !canEdit,
                                                classes: {
                                                    input: canEdit ? classes.input : classes.inputBlocked
                                                }
                                            }}
                                            control={control}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <TextField
                                            label={t("ownerCNPJ")}
                                            name="ownerCNPJ"
                                            className={classes.rootForm}
                                            InputProps={{
                                                readOnly: !canEdit,
                                                classes: {
                                                    input: canEdit ? classes.input : classes.inputBlocked
                                                }
                                            }}
                                            control={control}
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid item xs={1}>
                                        <TextField
                                            label={t("ownerRNTC")}
                                            name="ownerRNTC"
                                            className={classes.rootForm}
                                            InputProps={{
                                                readOnly: !canEdit,
                                                classes: {
                                                    input: canEdit ? classes.input : classes.inputBlocked
                                                }
                                            }}
                                            control={control}
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <TextField
                                            label={t("ownerCorporateName")}
                                            name="ownerCorporateName"
                                            className={classes.rootForm}
                                            InputProps={{
                                                readOnly: !canEdit,
                                                classes: {
                                                    input: canEdit ? classes.input : classes.inputBlocked
                                                }
                                            }}
                                            control={control}
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <TextField
                                            label={t("ownerIE")}
                                            name="ownerIE"
                                            className={classes.rootForm}
                                            InputProps={{
                                                readOnly: !canEdit,
                                                classes: {
                                                    input: canEdit ? classes.input : classes.inputBlocked
                                                }
                                            }}
                                            control={control}
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <If test={canEdit}>
                                            <Select
                                                name="ownerUFSelect"
                                                label={t('ownerUFCode')}
                                                options={listUFs}
                                                control={control}
                                            />
                                        </If>

                                        <If test={!canEdit}>
                                            <TextField
                                                label={t("ownerUFCode")}
                                                name="ownerUFCode"
                                                className={classes.rootForm}
                                                fullWidth
                                                InputProps={{
                                                    readOnly: true,
                                                    classes: {
                                                        input: classes.inputBlocked
                                                    }
                                                }}
                                                control={control}
                                            />
                                        </If>

                                    </Grid>
                                    </>
                                    }
                                </Grid>

                                <br />
                                <Divider />

                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <PageTitle title={t("totalizers")} />
                                    </Grid>
                                </Grid>
                                
                                <Grid container spacing={1}>

                                    <Grid item xs={2}>
                                        <TextField
                                            label={t("merchandiseTotalValue")}
                                            name="merchandiseTotalValue"
                                            required={true}
                                            className={classes.rootForm}
                                            fullWidth
                                            InputProps={{
                                                readOnly: !canEdit,
                                                classes: {
                                                    input: canEdit ? classes.input : classes.inputBlocked
                                                }
                                            }}
                                            control={control}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <TextField
                                            label={t("merchandiseTotalWeight")}
                                            name="merchandiseTotalWeight"
                                            required={true}
                                            className={classes.rootForm}
                                            InputProps={{
                                                readOnly: !canEdit,
                                                classes: {
                                                    input: canEdit ? classes.input : classes.inputBlocked
                                                }
                                            }}
                                            control={control}
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <If test={canEdit}>
                                        <Select
                                                name="merchandiseUnitySelect"
                                                required={true}
                                                label={t('merchandiseUnityCode')}
                                                options={listMerchandiseUnityCode}
                                                control={control}
                                            />
                                        </If>

                                        <If test={!canEdit}>
                                            <TextField
                                                label={t("merchandiseUnityCode")}
                                                name="merchandiseUnityCode"
                                                className={classes.rootForm}
                                                InputProps={{
                                                    readOnly: true,
                                                    classes: {
                                                        input: classes.inputBlocked
                                                    }
                                                }}
                                                control={control}
                                                fullWidth
                                            />
                                        </If>
                                    </Grid>

                                </Grid>

                                <br />
                                <Divider />
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <PageTitle title={t("unloading")} />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1}>
                                            <Grid item xs={2}>
                                                <Select
                                                    name="newUFUnloading"
                                                    label={t('uf')}
                                                    options={listUFs}
                                                    onChange={(item: any) => {
                                                        getListCitiesUnloading(item.code as string);
                                                    }}
                                                    control={control}
                                                />
                                            </Grid>

                                            <Grid item xs={4}>
                                                <Select
                                                    name="newCityUnloading"
                                                    label={t('city')}
                                                    options={listCitiesUnloading}
                                                    control={control}
                                                />
                                            </Grid>

                                            <Grid item xs={2}>
                                                <ButtonUI
                                                    color="primary"
                                                    variant="contained"
                                                    style={{
                                                        marginLeft: "15px",
                                                        minWidth: '20px'
                                                    }}
                                                    onClick={() => handleIncludeUnloading()}
                                                >
                                                    <AddIcon />
                                                </ButtonUI>
                                            </Grid>

                                        </Grid>

                                        <Grid container spacing={1}>

                                            <Grid item xs={11}>
                                                <MuiThemeProvider theme={myTheme}>
                                                    <MUIDataTable
                                                        title=""
                                                        data={mdfeUnloadings}
                                                        columns={columnsUnloadings}
                                                        options={{
                                                            ...options,
                                                            serverSide: false,
                                                            pagination: false,
                                                            sort: false,
                                                            selectToolbarPlacement: "none",
                                                            filter: false,
                                                            search: false,
                                                            download: false,
                                                            print: false,
                                                            viewColumns: false,
                                                            selectableRows: 'none',
                                                            tableBodyMaxHeight: `${window.innerHeight - 325}px`
                                                        }}
                                                    />
                                                </MuiThemeProvider>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <PageTitle title={t("route")} />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1}>

                                            <Grid item xs={2}>
                                                <Select
                                                    name="newUFRoute"
                                                    label={t('uf')}
                                                    options={listUFs}
                                                    control={control}
                                                />
                                            </Grid>

                                            <Grid item xs={2}>
                                                <ButtonUI
                                                    color="primary"
                                                    variant="contained"
                                                    style={{
                                                        marginLeft: "15px",
                                                        minWidth: '20px'
                                                    }}
                                                    onClick={() => handleIncludeRoute()}
                                                >
                                                    <AddIcon />
                                                </ButtonUI>
                                            </Grid>

                                        </Grid>

                                        <Grid container spacing={1}>

                                            <Grid item xs={11}>
                                                <MuiThemeProvider theme={myTheme}>
                                                    <MUIDataTable
                                                        title=""
                                                        data={mdfeRoutes}
                                                        columns={columnsRoutes}
                                                        options={{
                                                            ...options,
                                                            serverSide: false,
                                                            pagination: false,
                                                            sort: false,
                                                            selectToolbarPlacement: "none",
                                                            filter: false,
                                                            search: false,
                                                            download: false,
                                                            print: false,
                                                            viewColumns: false,
                                                            selectableRows: 'none',
                                                            tableBodyMaxHeight: `${window.innerHeight - 325}px`
                                                        }}
                                                    />
                                                </MuiThemeProvider>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </Grid>

                                <br />
                                <Divider />

                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <PageTitle title={t("conductors")} />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1}>

                                            <Grid item xs={6}>
                                                <TextField
                                                    label={t("name")}
                                                    name="newConductorName"
                                                    className={classes.rootForm}
                                                    fullWidth
                                                    InputLabelProps={{ style: { width: '150px' } }}
                                                    control={control}
                                                />
                                            </Grid>

                                            <Grid item xs={4}>

                                                <TextField
                                                    error={errorNewConductorCPF}
                                                    helperText={
                                                        errorNewConductorCPF ?
                                                            t("invalidCPF")
                                                            :
                                                            ""
                                                    }
                                                    label={t("cpf")}
                                                    name="newConductorCPF"
                                                    className={errorNewConductorCPF ? classes.rootFormError : classes.rootForm}
                                                    fullWidth
                                                    InputLabelProps={{ style: { width: '150px' } }}
                                                    InputProps={{
                                                        classes: {
                                                            input: errorNewConductorCPF ?
                                                                classes.inputError
                                                                :
                                                                classes.input
                                                        }
                                                    }}
                                                    control={control}
                                                />

                                            </Grid>

                                            <Grid item xs={2}>
                                                <ButtonUI
                                                    color="primary"
                                                    variant="contained"
                                                    style={{
                                                        marginLeft: "15px",
                                                        minWidth: '20px'
                                                    }}
                                                    onClick={handleIncludeConductor}
                                                >
                                                    <AddIcon />
                                                </ButtonUI>
                                            </Grid>

                                        </Grid>

                                        <Grid container spacing={1}>

                                            <Grid item xs={11}>
                                                <MuiThemeProvider theme={myTheme}>
                                                    <MUIDataTable
                                                        title=""
                                                        data={mdfeConductors}
                                                        columns={columnsConductors}
                                                        options={{
                                                            ...options,
                                                            serverSide: false,
                                                            pagination: false,
                                                            sort: false,
                                                            selectToolbarPlacement: "none",
                                                            filter: false,
                                                            search: false,
                                                            download: false,
                                                            print: false,
                                                            viewColumns: false,
                                                            selectableRows: 'none',
                                                            tableBodyMaxHeight: `${window.innerHeight - 325}px`
                                                        }}
                                                    />
                                                </MuiThemeProvider>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <PageTitle title={t("documents")} />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1}>

                                            <Grid item xs={9}>
                                                <TextField
                                                    error={errorNewInvoice}
                                                    helperText={
                                                        errorNewInvoice ?
                                                            t("invalidInvoice")
                                                            :
                                                            ""
                                                    }
                                                    type="text"
                                                    label={t("invoiceKey")}
                                                    name="newInvoiceKey"
                                                    className={errorNewInvoice ? classes.rootFormError : classes.rootForm}
                                                    fullWidth
                                                    InputLabelProps={{ style: { width: '150px' } }}
                                                    InputProps={{
                                                        classes: {
                                                            input: errorNewInvoice ?
                                                                classes.inputError: classes.input,
                                                        }
                                                    }}
                                                    FormHelperTextProps={{
                                                        classes:{
                                                            root:classes.rootFormError
                                                        }
                                                    }}                                                 
                                                    inputProps={{ maxLength: 44 }}
                                                    control={control}
                                                />
                                            </Grid>

                                            <Grid item xs={2}>
                                                <ButtonUI
                                                    color="primary"
                                                    variant="contained"
                                                    style={{
                                                        marginLeft: "15px",
                                                        minWidth: '20px'
                                                    }}
                                                    onClick={handleIncludeInvoice}
                                                >
                                                    <AddIcon />
                                                </ButtonUI>
                                            </Grid>

                                        </Grid>

                                        <Grid container spacing={1}>

                                            <Grid item xs={11}>
                                                <MuiThemeProvider theme={myTheme}>
                                                    <MUIDataTable
                                                        title=""
                                                        data={mdfeInvoices}
                                                        columns={columnsInvoices}
                                                        options={{
                                                            ...options,
                                                            serverSide: false,
                                                            pagination: false,
                                                            sort: false,
                                                            selectToolbarPlacement: "none",
                                                            filter: false,
                                                            search: false,
                                                            download: false,
                                                            print: false,
                                                            viewColumns: false,
                                                            selectableRows: 'none',
                                                            tableBodyMaxHeight: `${window.innerHeight - 325}px`
                                                        }}
                                                    />
                                                </MuiThemeProvider>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </Grid>

                                <br />
                                <Divider />
                                <br />

                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField
                                            label={t("observation")}
                                            id="observation"
                                            name="observation"
                                            multiline
                                            rows={4}
                                            fullWidth
                                            variant="outlined"
                                            style={{ margin: "0px" }}
                                            control={control}
                                        />
                                    </Grid>
                                </Grid>
                                                    
                                <br />
                                <br />
                                <br />
                        </form>
                    </React.Fragment>
            }
        </Container >
    )
}
export default MDFeDetail;
